import { DirectConnectRegistrationResponse } from '../model/direct-connect.model';

const getDirectConnectRegistration = async (
  url: string
): Promise<DirectConnectRegistrationResponse | undefined> => {
  const response = await fetch(new URL('api/registration/start', url), {
    method: 'GET',
  });

  if (response.ok) {
    const json = await response.json();
    return json as DirectConnectRegistrationResponse;
  }
};

export { getDirectConnectRegistration };
